import { useEffect, useState } from "react";
import Modal from "../../components/modal/modal.component";
import InputComponent from "../../components/input/input.component";
import SelectComponent from "../../components/select/select.component";
import DatepickerComponent from "../../components/datepicker/datepicker.component";
import { Controller, useForm } from "react-hook-form";
import TextareaComponent from "../../components/textarea/textarea.component";
import usePeriod from "../../hooks/period.use";
import { to } from "../../polyfill";
import { LoansService } from "../../services/operation/loans.service";
import AlertPeriod from "../../components/alert-period/alert-period";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import Button from "../../components/button/button.component";
import { LoanCreditsService } from "../../services/loan-credits";
import { UtilsService } from "../../services/utils";

function FormModal({ data, show, setShow }: any) {
  const { currentPeriod } = usePeriod();

  const [accounts, setAccounts] = useState<any[]>([])
  
  const defaultValues = {
    _id: '',
    period: currentPeriod._id,
    loan_credit: '',
    date: '',
    amount: 0,
    interest: 0,
    total_months: 0,
    comments: ''
  };

  const { watch, setValue, reset, register, handleSubmit, control, formState: { errors, isSubmitting, isValid }, } = useForm<typeof defaultValues>({
    mode: 'onChange',
    defaultValues,
  });

  const _id = watch('_id');

  const submit = async(form: typeof defaultValues) => {
    const [error, data] = await to(LoansService.save(form));
    if(error) {
      alert(error.message)
    } else {
      setShow(true)
      reset(defaultValues);
    }
  }

  const getList = async () => {
    const data = await LoanCreditsService.list();
    setAccounts(data.filter( (d: any) => d.status ));
  };

  useEffect(() => {
    getList();
  }, []);
  
  useEffect(() => {
    setValue('loan_credit', '');
  }, [accounts]);
  
  useEffect(() => {
    if(data) {
      reset({
        _id: data._id,
        period: currentPeriod._id,
        loan_credit: data.loan_credit._id,
        date: UtilsService.dateFormat(data.date, 'YYYY-MM-DD'),
        amount: data.amount,
        interest: data.interest,
        total_months: data.total_months,
        comments: data.comments,
      })
    }

    if(!show) {
      reset(defaultValues);
    }
  }, [data, show]);

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">{ !_id ? 'Agregar': 'Editar'} préstamo o crédito</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <AlertPeriod />
        </div>

    
        <div className="mb-5">
          <Controller
              name="date"
              control={control}
              rules={{ required: true }}
              render={({
                field: { onChange, value},
                fieldState: { error },
              }) => (
                <>
                  <DatepickerComponent
                    label="Fecha de deuda contraida *"
                    errors={error}
                    onChange={onChange}
                    value={value}
                  />
                  <InvalidFeedback error={error} />
                </>
              )}
            />
        </div>

        <div className="mb-5">
          <SelectComponent
            label="Cuenta *"
            data={accounts.map(a => ({ value: a._id, text: a.name }))}
            {...register('loan_credit', { required: true })} errors={errors.loan_credit}
          />
        </div>

        <div className="mb-5">
          <InputComponent label="Cantidad de deuda contraida *" {...register('amount', { required: true })} errors={errors.amount} />
        </div>
        
        <div className="mb-5">
          <InputComponent label="Interés anual en porcentaje (%) *" {...register('interest', { required: true })} errors={errors.interest}  />
        </div>
     
        <div className="mb-5">
          <InputComponent label="Plazo (meses) *" {...register('total_months', { required: true })} errors={errors.total_months}  />
        </div>

        <div className="mb-5">
          <TextareaComponent label="Condiciones *" {...register('comments', { required: true })} errors={errors.comments}  />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default FormModal;
